<template>
  <!-- 首页轮播图 -->
  <div class="home-banner">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.id">
        <img :src="item.logo" alt="" />
        <div class="absolute">
          <div
            class="title"
            :style="item.id == 2 || item.id == 3 ? 'color: #fff' : ''"
          >
            {{ item.title }}
          </div>
          <div
            class="text"
            :style="item.id == 2 || item.id == 3 ? 'color: #D1E8FF' : ''"
          >
            {{ item.text }}
          </div>
          <div
            class="experience"
            :style="
              item.id == 2 || item.id == 3
                ? 'color: #fff; border: 1px solid rgba(255,255,255, .8)'
                : ''
            "
            @click="experienceClick"
          >
            立即体验
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../components/mobile/components/Experience.vue";

import mobilebanner1 from "../../../assets/home/mobilebanner1.png";
import mobilebanner2 from "../../../assets/home/mobilebanner2.png";
import mobilebanner3 from "../../../assets/home/mobilebanner3.png";

export default {
  setup() {
    return reactive({
      bannerList: [
        {
          id: 1,
          logo: mobilebanner1,
          title: "畅月数字家园管理系统",
          text: "畅月数字家园管理系统是使物业、居委、业主、商家通过软硬一体化设备让智慧社区更具备运营能力 、盈利能力；使社区生活更加方便、快捷。",
        },
        {
          id: 2,
          logo: mobilebanner2,
          title: "移动办公",
          text: "APP+小程序全面实现移动办公，物业工作随时处理，效率更高更便捷",
        },
        {
          id: 3,
          logo: mobilebanner3,
          title: "智慧物业一体化优质服务商",
          text: "赋能物业、居委，助力物业智能化、数字化升级，打造智慧化社区新生态",
        },
      ],
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.home-banner img {
  width: 100%;
  height: 160px;
}
.relative {
  position: relative;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 18px;
  color: #248efb;
}
.absolute .text {
  font-size: 12px;
  margin-top: 13px;
  color: #248efb;
}
.absolute .experience {
  margin: 0 auto;
  margin-top: 5px;
  color: #248efb;
  border: 1px solid rgba(36, 142, 251, .8);
  text-align: center;
  cursor: pointer;
  width: 72px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  border-radius: 20px 20px 20px 20px;
}
</style>
